export const Schedule = [
  [
    // Sunday
    [
      { hour: 9, minute: 30 },
      "Class",
      "09:30",
      "Crossfit",
      { hour: 10, minute: 30 },
    ],
    [{ hour: 10, minute: 30 }, "Class end"],
    [
      { hour: 10, minute: 30 },
      "Class",
      "10:30",
      "Crossfit",
      { hour: 11, minute: 30 },
    ],
    [{ hour: 11, minute: 30 }, "Class end"],
  ],
  [
    // Monday
    [
      { hour: 11, minute: 45 },
      "Class",
      "11:45",
      "Crossfit",
      { hour: 12, minute: 45 },
    ],
    [{ hour: 12, minute: 45 }, "Class end"],
    [
      { hour: 16, minute: 30 },
      "Class",
      "16:30",
      "Crossfit",
      { hour: 17, minute: 30 },
    ],
    [{ hour: 17, minute: 30 }, "Class end"],
    [
      { hour: 17, minute: 30 },
      "Class",
      "17:30",
      "Crossfit",
      { hour: 18, minute: 30 },
    ],
    [{ hour: 18, minute: 30 }, "Class end"],
    [
      { hour: 18, minute: 30 },
      "Class",
      "18:30",
      "Crossfit",
      { hour: 19, minute: 30 },
    ],
    [{ hour: 19, minute: 30 }, "Class end"],
  ],
  // Tuesday
  [
    [
      { hour: 11, minute: 45 },
      "Class",
      "11:45",
      "Crossfit",
      { hour: 12, minute: 45 },
    ],
    [{ hour: 12, minute: 45 }, "Class end"],
    [
      { hour: 16, minute: 30 },
      "Class",
      "16:30",
      "Crossfit",
      { hour: 17, minute: 30 },
    ],
    [{ hour: 17, minute: 30 }, "Class end"],
    [
      { hour: 17, minute: 30 },
      "Class",
      "17:30",
      "Crossfit",
      { hour: 18, minute: 30 },
    ],
    [{ hour: 18, minute: 30 }, "Class end"],
    [
      { hour: 18, minute: 30 },
      "Class",
      "18:30",
      "Crossfit",
      { hour: 19, minute: 30 },
    ],
    [{ hour: 19, minute: 30 }, "Class end"],
  ],
  // Wednesday
  [
    [
      { hour: 10, minute: 0 },
      "Class",
      "10:00",
      "Crossfit",
      { hour: 11, minute: 0 },
    ],
    [{ hour: 11, minute: 0 }, "Class end"],
    [
      { hour: 11, minute: 45 },
      "Class",
      "11:45",
      "Crossfit",
      { hour: 12, minute: 45 },
    ],
    [{ hour: 12, minute: 45 }, "Class end"],
    [
      { hour: 16, minute: 30 },
      "Class",
      "16:30",
      "Crossfit",
      { hour: 17, minute: 30 },
    ],
    [{ hour: 17, minute: 30 }, "Class end"],
    [
      { hour: 17, minute: 30 },
      "Class",
      "17:30",
      "Crossfit",
      { hour: 18, minute: 30 },
    ],
    [{ hour: 18, minute: 30 }, "Class end"],
    [
      { hour: 18, minute: 30 },
      "Class",
      "18:30",
      "Crossfit",
      { hour: 19, minute: 30 },
    ],
    [{ hour: 19, minute: 30 }, "Class end"],
  ],
  // Thursday
  [
    [
      { hour: 11, minute: 45 },
      "Class",
      "11:45",
      "Crossfit",
      { hour: 12, minute: 45 },
    ],
    [{ hour: 12, minute: 45 }, "Class end"],
    [
      { hour: 16, minute: 30 },
      "Class",
      "16:30",
      "Crossfit",
      { hour: 17, minute: 30 },
    ],
    [{ hour: 17, minute: 30 }, "Class end"],
    [
      { hour: 17, minute: 30 },
      "Class",
      "17:30",
      "Crossfit",
      { hour: 18, minute: 30 },
    ],
    [{ hour: 18, minute: 30 }, "Class end"],
    [
      { hour: 18, minute: 30 },
      "Class",
      "18:30",
      "Crossfit",
      { hour: 19, minute: 30 },
    ],
    [{ hour: 19, minute: 30 }, "Class end"],
  ],
  // Friday
  [
    [
      { hour: 10, minute: 0 },
      "Class",
      "10:00",
      "Crossfit",
      { hour: 11, minute: 0 },
    ],
    [{ hour: 11, minute: 0 }, "Class end"],
    [
      { hour: 11, minute: 45 },
      "Class",
      "11:45",
      "Crossfit",
      { hour: 12, minute: 45 },
    ],
    [{ hour: 12, minute: 45 }, "Class end"],
    [
      { hour: 16, minute: 30 },
      "Class",
      "16:30",
      "Crossfit",
      { hour: 17, minute: 30 },
    ],
    [{ hour: 17, minute: 30 }, "Class end"],
    [
      { hour: 17, minute: 30 },
      "Class",
      "17:30",
      "Crossfit",
      { hour: 18, minute: 30 },
    ],
    [{ hour: 18, minute: 30 }, "Class end"],
  ],
  [
    // Saturday
    [
      { hour: 9, minute: 30 },
      "Class",
      "09:30",
      "Crossfit",
      { hour: 10, minute: 30 },
    ],
    [{ hour: 10, minute: 30 }, "Class end"],
    [
      { hour: 10, minute: 30 },
      "Class",
      "10:30",
      "Crossfit",
      { hour: 11, minute: 30 },
    ],
    [{ hour: 11, minute: 30 }, "Class end"],
  ],
];

export default {
  Schedule,
};
